enum COLOR {
  BLACK = '#000000',
  WHITE = '#FFFFFF',
  ALABASTER = '#FAFAFA',
  HONEYDEW = '#ebfff6',
  FLORAL_WHITE = '#fff8ef',
  SEASHELL = '#ffeeee',
  LAVENDER_GRAY = '#c1c9d5',
  SONIC_SILVER = '#757575',
  WHITE_SMOKE = '#F4F5F5',
  GREY_WHITE = '#E9EAEB',
  IRON = '#D5D7D9',
  ALUMINIUM = '#ABAFB2',
  GUNSMOKE = '#82878C',
  MID_GREY = '#585F66',
  OUTER_SPACE = '#2F3840',
  DARK_TURQUOISE = '#0EC8E6',
  YELLOW_ORANGE = '#FFA946',
  EMERALD = '#53df73',
  GO_GREEN = '#00b769',
  BEGONIA = '#FF7172',
  BLOOD_BURST = '#ff4d4f',
  VENETIAN_RED = '#DC0000',
  TOPAZ = '#ffc37a',
  ALICE_BLUE = '#EEF4FB',
  EAGLE_GREEN = '#004961',
  LAVENDER = '#E1EBFE',
  CHEMISTRY = '#24ACFA',
  BATTERY_CELLS = '#015AFF',
  BATTERY_PACKS = '#F6AD21',
  BATTERY_TECH_REVIEW = '#48D378',
  BATTERY_PACKS_REPAIR = '#24e2fa',
  BATTERY_REPURPOSE = '#019aff',
  BATTERY_PACKS_RECYCLING = '#f67821',
  BATTERY_WASTE = '#48d355',
}

export { COLOR };
